"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _underscore = require("underscore");

var _FormFields = require("lead-flows-ui/constants/FormFields");

var _ContactProperties = require("lead-flows-ui/constants/ContactProperties");

var _ContactPropertyOption = _interopRequireDefault(require("lead-flows-ui/lib/ContactPropertyOption"));

var _DEFAULT_CONTACT_PROP;

var ContactPropertyKeys = {
  DESCRIPTION: 'description',
  FIELD_TYPE: 'fieldType',
  FORM_FIELD: 'formField',
  GROUP_NAME: 'groupName',
  LABEL: 'label',
  NAME: 'name',
  TYPE: 'type',
  OPTIONS: 'options',
  SHOW_CURRENCY_SYMBOL: 'showCurrencySymbol'
};
var DEFAULT_CONTACT_PROPERTY = (_DEFAULT_CONTACT_PROP = {}, (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.DESCRIPTION, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.FIELD_TYPE, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.FORM_FIELD, true), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.GROUP_NAME, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.LABEL, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.NAME, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.TYPE, ''), (0, _defineProperty2.default)(_DEFAULT_CONTACT_PROP, ContactPropertyKeys.OPTIONS, []), _DEFAULT_CONTACT_PROP);

function getContactPropertyType(contactPropertyFieldType) {
  switch (contactPropertyFieldType) {
    case _FormFields.FieldTypes.TEXT:
    case _FormFields.FieldTypes.TEXTAREA:
    case _FormFields.FieldTypes.FILE:
      return 'string';

    case _FormFields.FieldTypes.SELECT:
    case _FormFields.FieldTypes.RADIO:
    case _FormFields.FieldTypes.CHECKBOX:
    case _FormFields.FieldTypes.SINGLE_CHECKBOX:
      return 'enumeration';

    case _FormFields.FieldTypes.NUMBER:
      return 'number';

    case _FormFields.FieldTypes.DATE:
      return 'date';

    default:
      return 'string';
  }
}

function updateRelevantProperties(contactProperty) {
  var fieldType = contactProperty.fieldType;
  var updatedProperty = contactProperty;

  if (fieldType !== _FormFields.FieldTypes.NUMBER) {
    updatedProperty = (0, _underscore.omit)(updatedProperty, 'showCurrencySymbol');
  }

  if (fieldType === _FormFields.FieldTypes.SINGLE_CHECKBOX) {
    updatedProperty = Object.assign({}, updatedProperty, {
      options: [new _ContactPropertyOption.default({
        label: 'Yes',
        value: true
      }), new _ContactPropertyOption.default({
        label: 'No',
        value: false
      })]
    });
  } else if (!_ContactProperties.FieldTypesWithOptions.hasOwnProperty(fieldType)) {
    updatedProperty = Object.assign({}, updatedProperty, {
      options: []
    });
  }

  return updatedProperty;
}

var ContactProperty = function ContactProperty(data) {
  (0, _classCallCheck2.default)(this, ContactProperty);
  var contactProperty = (0, _underscore.pick)(data, Object.values(ContactPropertyKeys || {}));
  var contactPropertyModified = {
    type: getContactPropertyType(contactProperty.fieldType)
  };
  return Object.assign({}, DEFAULT_CONTACT_PROPERTY, updateRelevantProperties(contactProperty), contactPropertyModified);
};

exports.default = ContactProperty;
module.exports = exports.default;